/* DBC behaviors for Whisk. One file, loaded once with defer from layout/theme.liquid.
   Everything is wired by data attribute and is safe on pages that carry none of them.

   [data-dbc-tabs]      tab list whose buttons carry data-filter; filters the sibling
                        [data-dbc-tab-grid] children by data-cat (each tab shows only its own cells).
                        Active state = .is-active + aria-selected. */
(function () {
  'use strict';

  if (window.__dbcNpCustom) return;
  window.__dbcNpCustom = true;

  function initTabs(tablist) {
    var scope = tablist.closest('[data-dbc-tabs-scope]') || tablist.parentElement;
    var grid = scope.querySelector('[data-dbc-tab-grid]');
    if (!grid) return;
    var empty = scope.querySelector('[data-dbc-tab-empty]');
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-filter]'));
    var cells = Array.prototype.slice.call(grid.children).filter(function (c) { return c.hasAttribute('data-cat'); });

    function apply(filter) {
      var shown = 0;
      cells.forEach(function (cell) {
        var on = cell.getAttribute('data-cat') === filter;
        cell.hidden = !on;
        if (on) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        apply(tab.getAttribute('data-filter'));
      });
    });

    var initial = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
    if (initial) {
      initial.classList.add('is-active');
      initial.setAttribute('aria-selected', 'true');
      apply(initial.getAttribute('data-filter'));
    }
  }

  /* [data-dbc-slider]  fading slider: [data-dbc-slide] children, [data-dbc-prev] / [data-dbc-next]
                        arrows, [data-dbc-dot="i"] dots. data-autoplay="seconds" advances on a timer,
                        paused on hover and focus, off when the visitor prefers reduced motion. */
  function initSlider(root) {
    if (root.dataset.dbcSliderReady) return;
    root.dataset.dbcSliderReady = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dbc-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dbc-dot]'));
    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); s.setAttribute('aria-hidden', n === index ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); d.setAttribute('aria-selected', n === index ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      var secs = parseFloat(root.dataset.autoplay);
      if (!secs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop(); timer = setInterval(function () { show(index + 1); }, secs * 1000);
    }

    var prev = root.querySelector('[data-dbc-prev]'), next = root.querySelector('[data-dbc-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.dbcDot, 10) || 0); start(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    show(index); start();
  }

  /* [data-dbc-carousel]  product carousel: [data-dbc-track] scrolls one card per press of
                          [data-dbc-cprev] / [data-dbc-cnext], wrapping at either end. data-autoplay="seconds"
                          advances on a timer, paused on hover and focus, off under reduced motion. Scroll
                          position is the state, so a swipe and an arrow press stay in sync. */
  function initCarousel(root) {
    if (root.dataset.dbcCarouselReady) return;
    root.dataset.dbcCarouselReady = '1';
    var track = root.querySelector('[data-dbc-track]');
    if (!track || track.children.length < 2) return;
    var timer = null;

    function stepWidth() {
      var items = track.children;
      if (items.length > 1) {
        var d = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        if (d > 1) return d;
      }
      return items[0].getBoundingClientRect().width + 16;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
    function advance(dir) {
      if (dir > 0) {
        if (atEnd()) track.scrollTo({ left: 0 });
        else track.scrollBy({ left: stepWidth() });
      } else {
        if (track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: -stepWidth() });
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      var secs = parseFloat(root.dataset.autoplay);
      if (!secs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop(); timer = setInterval(function () { advance(1); }, secs * 1000);
    }

    var prev = root.querySelector('[data-dbc-cprev]'), next = root.querySelector('[data-dbc-cnext]');
    if (prev) prev.addEventListener('click', function () { advance(-1); start(); });
    if (next) next.addEventListener('click', function () { advance(1); start(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    start();
  }

  function init() {
    document.querySelectorAll('[data-dbc-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-dbc-slider]').forEach(initSlider);
    document.querySelectorAll('[data-dbc-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run when a section is (re)loaded
  document.addEventListener('shopify:section:load', init);
})();
